import { render, staticRenderFns } from "./FastPayment.vue?vue&type=template&id=b55f3bce"
import script from "./FastPayment.vue?vue&type=script&lang=js"
export * from "./FastPayment.vue?vue&type=script&lang=js"
import style0 from "./FastPayment.vue?vue&type=style&index=0&id=b55f3bce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports